import React from 'react';

import { withReportsHistory } from './../../../shared/containers/containerReportsHistory';

import ButtonMediumDefault from './../../../shared/items/contols/buttonMediumDefault';

const ClearReportsHistoryButton = props => {
  const { onClearReportsHistory, reportsHistoryData } = props

  return (
    reportsHistoryData.length > 0
      ? <ButtonMediumDefault title="Очистить историю" handleClick={onClearReportsHistory} />
      : null
  )
}

export default withReportsHistory(React.memo(ClearReportsHistoryButton))